import React from "react"
import {findDOMNode} from "react-dom"

import Popover from "../../../../../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../../../../gd-components/gd-popover/popover-position"
import MoreProject_PopoverColorIcon from "../../../../../../gd-ui/more/project/compontent/selectors/popover-color-icon"

export default function FieldProjectColorIcon_Popover(props:any) {

    const menuParams = {
        project     : props.model,
        hidePopover : props.parent.hidePopover
    }

    return (
        <Popover position          = {new PopoverPosition({attachment: "top center", targetAttachment: "bottom center"})}
                 getTargetFunc      = {()=>findDOMNode(props.parent)}
                 onClickOutside     = {()=>{props.parent.hidePopover()}}>
            <MoreProject_PopoverColorIcon menuParams = {menuParams}/>
        </Popover>
    )
}
